import { render, staticRenderFns } from "./NavbarItems.vue?vue&type=template&id=1651c6ee&scoped=true&"
import script from "./NavbarItems.vue?vue&type=script&lang=js&"
export * from "./NavbarItems.vue?vue&type=script&lang=js&"
import style0 from "./NavbarItems.vue?vue&type=style&index=0&id=1651c6ee&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1651c6ee",
  null
  
)

export default component.exports